import type { Portal } from '@/features/iam/members/portal'
import { match } from '@/utils/pattern-match-util'

/**
 * Gets the display name of a portal.
 *
 * @param portal
 */
export function getPortalDisplayName(portal: Portal) {
  return match(portal, {
    CustomerPortal: 'Customer Portal',
    WorkPortal: 'Work Portal',
    Txf: 'TXF Portal',
  })
}
